import React, { FC, ChangeEvent, useState, useEffect } from 'react';

import Icon from '../../../../../@shared/icon';
import { iconSize } from '../../../../../../constants/icon.constants';
import { TTimeFieldRadio } from '../../../../types/timeField.types';
import DictionaryTerm from '../../../../../@shared/dictionaryTerm';

const MeridiemRadioGroup: FC<TTimeFieldRadio> = ({ handleSelectorClick, values, defaultValue, fields }) => {
  const [selectedValue, setSelectedValue] = useState('');

  useEffect(() => {
    if (!fields.value) {
      setSelectedValue(defaultValue);
    }
  }, [fields.value]);

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setSelectedValue(e.target?.value);
    handleSelectorClick(e.target?.value);
  };

  return (
    <div className="sitecore-jss-form__control sitecore-jss-form__control--time-selectors__meridiem-radio-btn-list">
      <ul>
        {values.map((item) => {
          return (
            <li key={item?.text}>
              <label>
                <input
                  type="radio"
                  form="novalidatedform"
                  className="sitecore-jss-form__field"
                  name="meridiemSelector"
                  value={item?.value}
                  onChange={onChange}
                  checked={selectedValue.includes(item.value)}
                />
                {selectedValue?.includes(item.value) ? (
                  <Icon
                    iconName="action-radio-checked"
                    size={iconSize.dsk}
                    extraClassName="sitecore-jss-form__control--time-selectors__meridiem-radio-btn"
                  />
                ) : (
                  <Icon
                    iconName="action-radio-default"
                    size={iconSize.dsk}
                    extraClassName="sitecore-jss-form__control--time-selectors__meridiem-radio-btn"
                  />
                )}
                <p className="sitecore-jss-form__control--time-selectors__meridiem-radio-btn-list-text"><DictionaryTerm keyword={item?.text} /></p>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MeridiemRadioGroup;
